import React from 'react';
import InfoStrip from './info-strip';
var WarningStrip = function (_a) {
    var content = _a.content;
    return React.createElement(InfoStrip, { level: "warning", content: content });
};
export default WarningStrip;
